<template>
    <BreadCrumb PageTitle="Modifier une opération" />
    <EditOperation />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditOperation from "../../components/Operation/EditOperation.vue";
  
    export default defineComponent({
      name: "EditOperationPage",
      components: {
        BreadCrumb,
        EditOperation,
      },
    });
  </script>